export default __webpack_public_path__ + "static/media/uel_efre.379976e6.jpeg";